import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutHalfFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="layout-half-full" maskId="round-filled-radius-0-stroke-1.5-IconLayoutHalfFull"><path d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V11.25L3 11.25V3.75Z" fill="currentColor"/><path d="M3 12.75V20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25V12.75L3 12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutHalfFull;
